export function titleName(title: string) {
  document.title = title;
}

export function changeOpacityTwo(e: any) {
  document.getElementById("mainFlexOne")!.style.opacity = "0.4";

  document.getElementById("mainFlexTwo")!.style.opacity = "1";
}
export function changeOpacityOne(e: any) {
  document.getElementById("mainFlexTwo")!.style.opacity = "0.4";

  document.getElementById("mainFlexOne")!.style.opacity = "1";
}

export function onMouseEnterOne(event: any) {
  document.getElementById("mainFlexTwo")!.style.opacity = "0.4";
}
export function onMouseLeaveOne(event: any) {
  document.getElementById("mainFlexTwo")!.style.opacity = "1";
}
export function onMouseEnterTwo(event: any) {
  document.getElementById("mainFlexOne")!.style.opacity = "0.4";
}
export function onMouseLeaveTwo(event: any) {
  document.getElementById("mainFlexOne")!.style.opacity = "1";
}
